import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, lineHeights, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { globalStyle, style } from '@vanilla-extract/css';
import { navbarHeight } from '@/constants/styles-vars';
import { sidebarWrapperCollapsed } from '../../sidebar.css';

// TODO: refactor MoreMenu to avoid css clash between menu item and dropdown menu item
export const moreMenuDropdownItem = style({
  selectors: {
    '&:is(&)': {
      margin: '0',
      flexDirection: 'row',
      justifyContent: 'start',
      backgroundColor: 'unset',

      padding: `${space.s10}px ${space.s16}px`,
      gap: space.s12,

      ...typography['labelMd'],
    },
  },
});

export const menuItemLinkCommonStyles = {
  tablet: {
    padding: space.s12,
    gap: space.s24,
  },
  laptop: {
    padding: `${space.s12}px ${space.s12}px`,
  },
};

const menuItemPaddingLeftRightLaptop = space.s35;
export const menuItemLink = style({
  color: themeVars.nav.button.foreground.idle,
  display: 'flex',
  cursor: 'pointer',
  width: '100%',
  backgroundColor: 'transparent',

  selectors: {
    '&:hover:is(&)': {
      color: themeVars.nav.button.foreground.idle,
      backgroundColor: themeVars.nav.button.background.hover,
    },
    '&:active:is(&)': {
      color: themeVars.nav.button.foreground.selected,
      backgroundColor: themeVars.nav.button.background.active,
    },
    '&.active:is(&)': {
      color: themeVars.nav.button.foreground.selected,
    },
  },

  ...responsiveStyle({
    mobile: {
      ...typography['bodySm'],
      gap: space.s2,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: `${space.s6}px 0`,
      borderRadius: 0,
      maxHeight: navbarHeight,
    },
    tablet: {
      ...typography['labelLg'],
      borderRadius: borderRadius.r12,
      padding: menuItemLinkCommonStyles.tablet.padding,
      gap: menuItemLinkCommonStyles.tablet.gap,
      flexDirection: 'row',
      maxHeight: 'max-content',
      width: '48px',
      overflow: 'hidden',
    },
    laptop: {
      padding: `${space.s12}px ${menuItemPaddingLeftRightLaptop}px`,
      justifyContent: 'start',
      width: '270px',
      transition: '0.15s ease',
    },
  }),
});
export const menuItemButton = style([
  menuItemLink,
  {
    padding: 0,

    selectors: {
      '&[data-active]:is(&)': {
        color: themeVars.nav.button.foreground.selected,
      },
    },
  },
]);

globalStyle(`${menuItemButton} svg`, {
  width: 24,
  height: 24,
});

export const menuItemText = style({
  whiteSpace: 'nowrap',
  ...responsiveStyle({
    tablet: {
      display: 'none',
    },
    laptop: {
      display: 'block',
    },
  }),
});
export const iconContainer = style({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
});
export const menuItemBadge = style({
  ...typography['labelSm'],

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  backgroundColor: themeVars.color.bg.alert.critical.default,
  lineHeight: lineHeights.none,
  padding: `0 ${space.s3}px`,
  borderRadius: 9999,
  color: themeVars.color.text.inverse,
  textAlign: 'center',
  fontSize: 11,
  right: -5,
  top: -3,
  height: 15,
  minWidth: 15,
});

globalStyle(`.${sidebarWrapperCollapsed} .${menuItemLink}`, {
  padding: space.s12,
  width: 48,
  overflow: 'hidden',
});

export const subMenu = style([
  {
    transition: '0.15s ease',

    borderLeft: `1px solid ${themeVars.nav.button.foreground.idle}`,
    margin: `${space.s8}px 0`,
  },
  responsiveStyle({
    mobile: {},
    tablet: {},
    laptop: {
      marginLeft: menuItemPaddingLeftRightLaptop + space.s12,
    },
  }),
]);

// support smooth sidebar animation
globalStyle(`.${sidebarWrapperCollapsed} .${subMenu}`, {
  width: 0,
  overflow: 'hidden',
  marginLeft: space.s24,
});

export const collapsibleMenuItemContainer = style([
  {
    opacity: 1,
    height: '100%',
    width: '100%',
    overflow: 'hidden',

    selectors: {
      '&[data-hidden]': {
        opacity: 0,
        height: 0,
        width: 0,
      },
    },
  },
]);

export const subMenuItemLink = style([
  menuItemLink,
  {
    marginLeft: space.s16,

    selectors: {
      '&:is(&)': {
        width: 'auto',
      },
    },
  },
  responsiveStyle({
    mobile: {},
    tablet: {},
    laptop: {
      selectors: {
        '&:is(&)': {
          ...typography['labelMd'],
          padding: `${space.s10}px ${space.s20}px`,
        },
      },
    },
  }),
]);

export const navArrowButton = style([
  subMenuItemLink,
  {
    gap: space.s4,
  },
]);

export const navArrowDown = style({
  transform: 'rotate(90deg)',
});

export const navArrowUp = style({
  transform: 'rotate(-90deg)',
});

export const streamDeckSubMenuLink = style({
  selectors: {
    '&.active:is(&)': {
      color: themeVars.nav.button.foreground.idle,
    },
  },
});
